export default __webpack_public_path__ + "static/media/cactus.27a5c470.png";